<template>
    <div class="relative" :class="className">
        <label
            class="input-control input-control--checkbox | font-normal text-grey-800"
            :class="[sizeClass, { 'pointer-events-none': readonly }]"
        >
            <div
                class="mr-2"
                :class="disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
                v-if="$slots.before"
            >
                <slot name="before" />
            </div>
            <input
                :id="computedId"
                type="checkbox"
                :checked="resolvedValue"
                :disabled="disabled"
                :tabindex="tabindex"
                ref="input"
                @change.stop="onChange"
                @click.stop="onClickToggle"
                @input.stop
            />
            <div class="input-control__indicator" :class="[colorClass, symbolClass]" />
            <div
                class="ml-2"
                :class="disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
                v-if="$slots.default"
            >
                <slot />
            </div>
        </label>
    </div>
</template>

<script>
    import { uniqueId } from 'lodash-es';

    export default {
        name: 'ActivixCheckbox',

        compatConfig: {
            MODE: 3,
            COMPONENT_V_MODEL: false,
        },

        emits: ['input', 'update:modelValue', 'click'],

        props: {
            id: {
                type: [String, Number],
                default: '',
            },
            modelValue: {
                type: Boolean,
                default: undefined,
            },
            value: {
                type: Boolean,
                default: false,
            },
            color: {
                type: String,
                default: 'blue',
                validator: (value) => ['blue', 'green', 'purple', 'orange', 'red'].includes(value),
            },
            cross: {
                type: Boolean,
                default: false,
            },
            size: {
                type: String,
                default: 'md',
                validator: (value) => ['xs', 'sm', 'md', 'lg'].includes(value),
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            tabindex: {
                type: String,
                default: '',
            },
            readonly: {
                type: Boolean,
                default: false,
            },
            className: {
                type: [String, Array, Object],
                default: 'inline-flex',
            },
        },

        computed: {
            resolvedValue() {
                return this.modelValue !== undefined ? this.modelValue : this.value;
            },

            colorClass() {
                return this.color ? `checkbox-${this.color}` : '';
            },

            computedId() {
                return this.id || uniqueId('checkbox-');
            },

            sizeClass() {
                return this.size ? `checkbox-${this.size}` : '';
            },

            symbolClass() {
                return this.cross ? 'cross' : '';
            },
        },

        methods: {
            onClickToggle(event) {
                this.$emit('click', event);

                if (event?.defaultPrevented) {
                    setTimeout(this.syncNativeChecked);
                }
            },

            onChange(event) {
                const checked = event.target.checked;

                this.$emit('input', checked);
                this.$emit('update:modelValue', checked);
            },

            syncNativeChecked() {
                if (!this.$refs.input) {
                    return;
                }

                this.$refs.input.checked = this.resolvedValue;
            },
        },
    };
</script>
